import ga from 'react-ga'

export class AnalyticsStore {
  public static initialize(code: string) {
    ga.initialize(code, {
      titleCase: false,
      gaOptions: {
        siteSpeedSampleRate: 100,
      },
    })
  }

  public static setUserID(userID: string) {
    ga.set({ userId: userID })
  }

  public static navigation(path: string) {
    ga.pageview(path)
  }

  public static event(category: string, action: string) {
    console.log('event', { category, action })

    ga.event({ category, action })
  }

  public static error(category: string, action: string, error: Error) {
    ga.exception({
      category,
      action,
      ...error,
    })
  }

  public static timing(category: string, action: string, time: number) {
    ga.timing({
      category,
      variable: 'load',
      label: action,
      value: time,
    })
  }
}

export const analyze = (category: string, action: string) => {
  return function (_, __, descriptor: PropertyDescriptor) {
    const method = descriptor.value

    descriptor.value = function (...args) {
      AnalyticsStore.event(category, action)

      const start = Date.now()

      return method
        .apply(this, args)
        .catch((error) => {
          AnalyticsStore.error(category, action, error)

          throw error
        })
        .finally(() => {
          AnalyticsStore.timing(category, action, Date.now() - start)
        })
    }
  }
}
